/**
 * Serviceplan MAKEOS
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { BuyoutRightFields } from './buyoutRightFields';


export interface MakeBuyoutRights { 
    _id: string;
    buyoutRightsTitle: string;
    buyoutRights: Array<BuyoutRightFields>;
}

